import { keepPreviousData } from '@tanstack/react-query';

import { Environment } from '@playq/octopus-common';
import { GenericFailure } from '@playq/services-shared';
import { Vault, VaultId } from '@playq/services-vault';

import { IUseQueryOptionsExtended, useEitherQuery } from '/api/service-hooks';
import { services2 } from '/api/services2';

import { playerLookupKeys } from './constants';

export const useRetriveVault = (
  { id, env }: { id: VaultId; env: Environment },
  options?: IUseQueryOptionsExtended<Vault | undefined, GenericFailure | Error>
) => {
  return useEitherQuery(
    playerLookupKeys.currentVault(id, env),
    () => {
      return services2.vaultLookupService.fetchVault(id, env);
    },
    {
      placeholderData: keepPreviousData,
      ...options,
    }
  );
};
